import { render, staticRenderFns } from "./DastPromoFeature.vue?vue&type=template&id=20b5b640&scoped=true"
import script from "./DastPromoFeature.vue?vue&type=script&lang=js"
export * from "./DastPromoFeature.vue?vue&type=script&lang=js"
import style0 from "./DastPromoFeature.vue?vue&type=style&index=0&id=20b5b640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b5b640",
  null
  
)

export default component.exports